import React,{useState} from 'react';
import {Form,Col,Container,Table,Button,Modal,Tab,Tabs} from 'react-bootstrap';
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import Title from '../../utilities/other/title';
import SideMenu from '../../utilities/sideMenu/menu'
import Part3 from './Part3'
import Part1 from './umsars_p1_data.json'
import Part2 from './umsars_p2_data.json'
import Part from './Part'
import Part4 from './part4_data.json'



class Umsars extends React.Component{
    constructor(props){
        super(props);
        this.state = {}
        // this.handleNewCriteria = this.handleNewCriteria.bind(this)
    }
    handleScore = (name,score)=>{
        this.setState((prevState)=>({
            ...prevState,
            [name]:score
        }))
    }
    
    
    onChange = async (event)=>{
        const {name,value} = event.target
        
       await this.setState((prevState)=>({
            ...prevState,
            
           
                [name]:value
            
        }))
        let state = this.state
        delete state.umsars_new
        this.props.handler('umsars',state)
    }
    handleChangeState = async (state)=>{
        // const data = state['data']
        // this.setState(data)
        await this.setState((prevState)=>({
            ...prevState,


            ...state

        }))
        this.props.handler('umsars',state)

    }
    // componentDidMount(){
    //    if(this.props.data!= null){
    //        this.setState(this.props.data)
    //    }
    // }
    // async handleNewCriteria(new_state){
    //     await this.setState((prevState) =>({
    //         ...prevState,
    //         umsars_new:new_state
    //     }))
    //     this.props.handler('umsars_new',this.state.umsars_new)
    // }
    
    // componentDidUpdate(prevProps, prevState){
    //     if (prevState != this.state){
    //         this.props.handler('umsars',this.state)
    //     }
    //     // if (prevState != this.state){
    //     //     this.props.handler('umsars',this.state)
    //     // }
    // }
    render(){
        return(
            <div>
              
                {/* <Table responsive={true} bordered={false}  hover={true} striped={false}>

                </Table> */}
                
                        <Title>Unified MSA Rating Scale</Title>
                        <SideMenu defaultKey={'p1'}>
                        <Part indexKey={'p1'} disabled={this.props.disabled} title={'Part 1: Historical Review'} data={this.props.data!=null?this.props.data:null} onChange={this.onChange} score={this.handleScore} questions={Part1} score_name={'p1_score'}/>
                        <Part indexKey={'p2'} disabled={this.props.disabled} title={'Part 2: Motor Examination Scale'} onChange={this.onChange}  data={this.props.data!=null?this.props.data:null} score={this.handleScore} questions={Part2} score_name={'p2_score'}/>
                        <Part3 indexKey={'p3'} disabled={this.props.disabled} title={'Part 3: Autonomic Examination'} hanlder={this.handleChangeState}  data={this.props.data!=null?this.props.data:null} />
                        <Part indexKey={'p4'} disabled={this.props.disabled}  title={'Part 4: Global Disability Scale'} onChange={this.onChange}  data={this.props.data!=null?this.props.data:null} score={this.handleScore} questions={Part4} score_name={'p4_score'}/>
                    </SideMenu>
                    
                    {/* <Tab eventKey={"new-guidelines"} title={"New Guidelines"}>
                        <Umsars_new handler={this.handleNewCriteria}
                            data={this.props.data!=null?this.props.data[1]:null}
                            disabled={this.props.disabled} 
                        />

                    </Tab> */}
                
                
            </div>
        )
    }
}
Umsars.defaultProps = {
    data:null,
    disabled:false
}

export default Umsars